import'react-native-gesture-handler';import{App}from"./src/app";export default App;